<template>
  <p class="error">
    <slot></slot>
  </p>
</template>

<script>
export default {
  name: "InputHintAddressError",
  props: {
    hint: String,
    error: String,
    required: {
      type: Boolean,
      default: false
    },
    showOptional: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
p {
  position: relative;
  padding: 0 $padding-input-left;
  margin-top: 5px;

  font-size: $font-size-sm;
  color: $label-gray;

  span {
    font-style: oblique;
  }

  &.error {
    color: $red-active;
  }
}
</style>
